(() => {
  const nav = document.querySelector('[data-secondary-nav]'),
      inner = nav.querySelector('[data-secondary-inner]'),
     toggle = nav.querySelector('[data-secondary-toggle]'),
      links = nav.querySelectorAll('.secondary_nav__link');

  links && links.forEach(link => (window.location.href === link.href) && link.parentElement.classList.add('active'));
  toggle && inner && toggle.addEventListener('click', () => inner.classList.toggle('opened'));

  if (nav && nav.classList.contains('sticky')) {
    let reset;
    const height = () => document.documentElement.style.setProperty('--secondary-height', `${(nav ? nav.offsetHeight : 0)}px`),
     resetHeight = () => {
       clearTimeout(reset);
       reset = setTimeout(height, 50);
     };

    window.addEventListener('resize', resetHeight);
    window.addEventListener('orientationchange', resetHeight);
    document.addEventListener('readystatechange', e => (e.target.readyState === 'complete') && height());
  }
})();
